import { render, staticRenderFns } from "./helpItem.vue?vue&type=template&id=87733046&scoped=true"
import script from "./helpItem.vue?vue&type=script&lang=js"
export * from "./helpItem.vue?vue&type=script&lang=js"
import style0 from "./helpItem.vue?vue&type=style&index=0&id=87733046&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87733046",
  null
  
)

export default component.exports